import { Tooltip } from "@mui/material";
import truncateString from "helpers/truncateString";
import Flex from "./Flex";
import theme from "theme";
import { P } from "theme/typography";
import { ReactNode } from "react";

export interface DocumentNameProps {
  name: string;
  onClick?: () => void;
  altName?: string;
  children?: ReactNode;
  maxWidth?: string;
}

const DocumentName = (props: DocumentNameProps) => {
  const { name, onClick, altName, children, maxWidth } = props;

  return (
    <Flex>
      <Tooltip arrow title={`Open '${name}'`}>
        <P
          sx={{
            ...theme.mixins.linkLike,
            margin: "auto 0",
            fontSize: "0.70rem",
            fontWeight: "bold",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: maxWidth ?? "250px",
          }}
          onClick={onClick}>
          {altName ? altName : truncateString(name, 60)}
          {children}
        </P>
      </Tooltip>
    </Flex>
  );
};

export default DocumentName;
